import styled from "styled-components";

const CLINICAL_50 = "#f0f9ff";
const CLINICAL_100 = "#e0f2fe";
const CLINICAL_600 = "#0284c7";
const CLINICAL_700 = "#0369a1";
const CLINICAL_800 = "#075985";

export const Page = styled.div`
  height: 100%;
  overflow: auto;
  background: #f8fafc;
  color: #0f172a;
`;

export const Wrapper = styled.div`
  max-width: 64rem;
  margin: 0 auto;
  padding: 24px 16px;

  @media (min-width: 1024px) {
    padding: 48px 16px;
  }
`;

export const HeaderCard = styled.header`
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #f1f5f9;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
  margin-bottom: 24px;
`;

export const HeaderTop = styled.div`
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 24px;
  margin-bottom: 24px;
`;

export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
  background: ${CLINICAL_100};
  color: ${CLINICAL_800};
  margin-bottom: 12px;
`;

export const H1 = styled.h1`
  margin: 0;
  font-size: 2rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #0f172a;
`;

export const SubTitle = styled.p`
  margin: 8px 0 0 0;
  font-size: 0.9rem;
  color: #64748b;
`;

export const LegalBox = styled.div`
  background: ${CLINICAL_50};
  border-radius: 12px;
  padding: 16px;
  border: 1px solid ${CLINICAL_100};
  font-size: 0.9rem;
  color: #0f172a;
`;

export const LegalTitle = styled.div`
  font-weight: 800;
  color: ${CLINICAL_800};
  margin-bottom: 8px;
`;

export const LegalList = styled.ul`
  margin: 0;
  padding-left: 18px;
  color: ${CLINICAL_700};
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Button = styled.button`
  border: 1px solid ${(p) => (p.$primary ? "transparent" : "#e2e8f0")};
  background: ${(p) => (p.$primary ? CLINICAL_600 : "#0f172a")};
  color: ${(p) => (p.$primary ? "#ffffff" : "#e2e8f0")};
  padding: 10px 14px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  box-shadow: ${(p) => (p.$primary ? "0 8px 18px rgba(2, 132, 199, 0.2)" : "none")};
  transition: background 120ms ease, box-shadow 120ms ease, border-color 120ms ease, color 120ms ease;

  &:hover {
    background: ${(p) => (p.$primary ? CLINICAL_700 : "#1f2937")};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const PatientBox = styled.div`
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  padding: 14px;
  background: #f8fafc;
`;

export const Small = styled.div`
  font-size: 0.85rem;
  color: #475569;
`;

export const Strong = styled.div`
  font-weight: 800;
  color: #0f172a;
`;

export const StrongInherit = styled.div`
  font-weight: 800;
  color: inherit;
`;

export const HistoricoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const HistoricoItem = styled.button`
  border: 1px solid ${(p) => (p.$active ? "transparent" : "#e2e8f0")};
  border-radius: 12px;
  padding: 12px;
  background: ${(p) => (p.$active ? CLINICAL_600 : "#ffffff")};
  color: ${(p) => (p.$active ? "#ffffff" : "#0f172a")};
  text-align: left;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;

  &:hover {
    background: ${(p) => (p.$active ? CLINICAL_700 : "#f8fafc")};
  }
`;

export const FormPanel = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Section = styled.fieldset`
  border: 1px solid #f1f5f9;
  border-radius: 16px;
  padding: 24px;
  margin: 0;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);

  @media (min-width: 768px) {
    padding: 32px;
  }
`;

export const Legend = styled.legend`
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 800;
  font-size: 1.15rem;
  padding: 0 6px;
  color: #0f172a;

  &::before {
    content: "";
    width: 8px;
    height: 24px;
    border-radius: 9999px;
    background: ${CLINICAL_600};
    display: inline-block;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 16px;
`;

export const Field = styled.div`
  grid-column: span ${(p) => p.$span || 12};
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (max-width: 768px) {
    grid-column: span 12;
  }
`;

export const Label = styled.label`
  font-size: 0.85rem;
  font-weight: 700;
  color: #334155;
`;

export const Input = styled.input`
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 12px;
  background: rgba(248, 250, 252, 0.6);
  color: #0f172a;
  outline: none;
  transition: box-shadow 120ms ease, background 120ms ease, border-color 120ms ease;

  &:focus {
    background: #ffffff;
    border-color: ${CLINICAL_600};
    box-shadow: 0 0 0 3px rgba(2, 132, 199, 0.18);
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 12px;
  background: rgba(248, 250, 252, 0.6);
  color: #0f172a;
  outline: none;
  transition: box-shadow 120ms ease, background 120ms ease, border-color 120ms ease;

  &:focus {
    background: #ffffff;
    border-color: ${CLINICAL_600};
    box-shadow: 0 0 0 3px rgba(2, 132, 199, 0.18);
  }
`;

export const Select = styled.select`
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 12px;
  background: rgba(248, 250, 252, 0.6);
  color: #0f172a;
  outline: none;
  transition: box-shadow 120ms ease, background 120ms ease, border-color 120ms ease;

  &:focus {
    background: #ffffff;
    border-color: ${CLINICAL_600};
    box-shadow: 0 0 0 3px rgba(2, 132, 199, 0.18);
  }
`;

export const CheckRow = styled.label`
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
  font-size: 0.85rem;
  color: #334155;

  input[type="checkbox"],
  input[type="radio"] {
    accent-color: ${CLINICAL_600};
  }
`;

export const RadioRow = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

export const RadioColumn = styled(RadioRow)`
  flex-direction: column;
  gap: 8px;
  flex-wrap: nowrap;
  align-items: flex-start;
`;

export const TextareaTall = styled(Textarea)`
  min-height: 140px;
`;

export const BlockSubtitle = styled.div`
  font-size: 0.85rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 6px;
`;

export const PatientActions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const PatientGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const FooterActions = styled.div`
  margin-top: 8px;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
`;

export const Spacer = styled.div`
  height: ${(p) => p.$h || "12px"};
`;

export const SectionTopRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

export const Divider = styled.hr`
  border: 0;
  border-top: 1px solid #f1f5f9;
  margin: 24px 0;
`;

export const HistoryTitle = styled.div`
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 10px;
`;

export const SectionDescription = styled.p`
  margin: -8px 0 16px 0;
  font-size: 0.75rem;
  color: #64748b;
`;

export const InnerFieldset = styled.fieldset`
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  background: rgba(248, 250, 252, 0.6);
`;

export const InnerFieldsetSolid = styled(InnerFieldset)`
  background: #f8fafc;
`;

export const InnerLegend = styled.legend`
  font-size: 0.85rem;
  font-weight: 700;
  color: #1e293b;
  padding: 0 8px;
`;

export const WhiteCompactInput = styled(Input)`
  background: #ffffff;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 0.75rem;

  &::placeholder {
    color: #94a3b8;
  }
`;

export const TinyCheckRow = styled(CheckRow)`
  font-size: 0.75rem;
  color: #475569;
`;

export const RedUpper = styled.p`
  margin: 0;
  font-size: 0.7rem;
  font-weight: 700;
  color: #dc2626;
  text-transform: uppercase;
  letter-spacing: 0.08em;
`;

export const TinyNote = styled.p`
  margin: 8px 0 0 0;
  font-size: 11px;
  color: #94a3b8;
`;

export const IndigoSection = styled(Section)`
  background: #1e1b4b;
  border-color: rgba(67, 56, 202, 0.35);
  box-shadow: 0 10px 18px rgba(30, 27, 75, 0.25);

  ${Legend} {
    color: #eef2ff;
  }
`;

export const IndigoLabel = styled(Label)`
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #a5b4fc;
`;

export const IndigoInput = styled(Input)`
  background: rgba(49, 46, 129, 0.4);
  border-color: rgba(67, 56, 202, 0.5);
  color: #ffffff;

  &:focus {
    background: #312e81;
    border-color: ${CLINICAL_600};
    box-shadow: 0 0 0 3px rgba(2, 132, 199, 0.25);
  }
`;

export const IndigoFieldset = styled.fieldset`
  grid-column: span 12;
  background: rgba(49, 46, 129, 0.3);
  border: 1px solid rgba(55, 48, 163, 0.6);
  border-radius: 12px;
  padding: 14px;
`;

export const IndigoLegend = styled.legend`
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #a5b4fc;
  padding: 0 8px;
`;

export const IndigoCheckRow = styled(CheckRow)`
  font-size: 0.75rem;
  color: #e0e7ff;

  input[type="checkbox"] {
    accent-color: ${CLINICAL_600};
  }
`;

export const AmberFieldset = styled.fieldset`
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #fef3c7;
  background: rgba(255, 251, 235, 0.3);
`;

export const AmberLegend = styled.legend`
  font-size: 0.85rem;
  font-weight: 700;
  color: #78350f;
  background: #fef3c7;
  padding: 4px 12px;
  border-radius: 9999px;
`;

export const AmberNote = styled.p`
  margin: 10px 0 0 0;
  font-size: 0.75rem;
  color: #92400e;
`;

export const SelectAllRow = styled.label`
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.75rem;
  font-weight: 800;
  color: #0f172a;
  cursor: pointer;

  input[type="checkbox"] {
    accent-color: ${CLINICAL_600};
  }
`;
